<template>
  <div>
    <ConfirmModal
      v-if="tryToDelete"
      :onCloseTryToDeleteModal="onCloseTryToDeleteModal"
      :onConfirm="onDeleteConfirmButtonClicked">
      <template v-slot:header-title>
        <h4>ยืนยันการลบ</h4>
      </template>
      <div v-if="!deleteGalleryState.isDeleting && !deleteGalleryState.error">
        คุณยืนยันที่จะลบแกลเลอรี {{ currentGallery.title }}
      </div>
      <div v-if="!deleteGalleryState.isDeleting && deleteGalleryState.error">
        เกิดข้อผิดพลาดขณะลบแกลเลอรี <br>
        {{ deleteGalleryState.error }}
      </div>
    </ConfirmModal>
    <Page class="galleryEditChrome">
      <template v-slot:page-header>
        <div class="container">
          <div
            v-if="!galleryCannotBeLoaded"
            class="page-header">
            <button
              class="btn btn-action btn-action-back"
              @click.stop="onGoBackButtonClicked">
              <i class="fas fa-chevron-left" />
            </button>
            <div class="title-container">
              <div class="title">แก้ไขแกลเลอรี</div>
            </div>
            <div class="actions">
              <small
                class="text-danger mr-3"
                v-if="saveGalleryState.error">
                พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ <br>
                {{ error }}
              </small>
              <small
                class="text-success font-weight-bold mr-3"
                v-if="!saveGalleryState.error && saveGalleryState.isSaved">
                <i class="fa fa-check" /> บันทึกแล้ว
              </small>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="galleryHasAnError"
                @click.stop="onSaveGalleryButtonClicked">
                บันทึก
              </button>
              <Dropdown alignment="right">
                <template v-slot:dropdow-button>
                  <button
                    type="button"
                    class="btn btn-outline-dark btn-action m-0 ml-2">
                    <i class="fas fa-cog"></i>
                  </button>
                </template>
                <div
                  class="dropdown-item"
                  @click.stop="toggleDelete">
                  ลบแกลเลอรี
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </template>
      <div class="container">
        <PreloaderSection
          v-if="galleryIsLoading"/>
        <ErrorMessageGalleryContainer
          v-if="galleryCannotBeLoaded"
          :error="galleryCannotBeLoaded"
          redirectLink="/galleries" />
        <div v-if="!galleryIsLoading && currentGallery">
          <GalleryEditingAreaComponent
            :modal="false"/>
        </div>
      </div>
    </Page>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ConfirmModal from '@/components/ConfirmModal.vue';
import Dropdown from '@/components/Dropdown.vue';
import Page from '@/layouts/Page.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';

import ErrorMessageGalleryContainer from './components/ErrorMessageGalleryContainer.vue';
import GalleryEditingAreaComponent from './components/GalleryEditingAreaComponent.vue';

export default {
  components: {
    Page,
    PreloaderSection,
    Dropdown,
    ConfirmModal,
    GalleryEditingAreaComponent,
    ErrorMessageGalleryContainer,
  },
  data() {
    return {
      tryToDelete: false,
    };
  },
  computed: {
    ...mapGetters([
      'currentGallery',
      'currentGalleryWasEdited',
      'deleteGalleryState',
      'loadCurrentGalleryState',
      'saveGalleryState',
    ]),
    galleryKey() {
      return this.$route.params.galleryKey;
    },
    galleryCannotBeLoaded() {
      return this.loadCurrentGalleryState.error.statusCode;
    },
    galleryHasAnError() {
      return !!this.currentGalleryWasEdited.errors.length;
    },
    galleryIsLoading() {
      return this.loadCurrentGalleryState.isLoading;
    },
  },
  created() {
    this.loadCurrentGallery(this.galleryKey);
  },
  methods: {
    ...mapActions([
      'loadCurrentGallery',
      'destroyCurrentGalleryState',
      'deleteCurrentGallery',
      'saveCurrentGallery',
    ]),
    async onSaveGalleryButtonClicked() {
      await this.saveCurrentGallery();
    },
    async onDeleteConfirmButtonClicked() {
      await this.deleteCurrentGallery(this.galleryKey);
      await this.$router.push('/galleries');
    },
    toggleDelete() {
      this.tryToDelete = true;
    },
    onCloseTryToDeleteModal() {
      this.tryToDelete = false;
    },
    onGoBackButtonClicked() {
      if (this.currentGalleryWasEdited.wasEdited) {
        // eslint-disable-next-line no-restricted-globals,no-alert
        if (!confirm('มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก\nคุณยืนยันที่จะออกจากหน้าจัดการแกลเลอรีโดยไม่บันทึกข้อมูล ?')) {
          return;
        }
      }
      this.$router.push('/galleries');
      this.destroyCurrentGalleryState();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables';
@import '../assets/scss/themes/components/section-container';
.gallery-form {
  margin-top: 10px;
}
textarea {
  min-height: 110px;
}
.modal-content {
  .page-header {
    display: flex;
    flex-flow: row;
    width: 100%;
    align-items: center;
    padding: 20px 32px 0;
    justify-content: space-between;

    h1 {
      font-size: 20px;

      i {
        cursor: pointer;
      }
    }

    .actions {
      display: flex;
      flex-flow: row;
    }
  }
}
.alert {
  border-radius: 0.25rem;
}
@media screen and (max-width: 575.98px) {
  .galleryEditChrome {
    .page-body {
      .container {
        padding: 0;
        .col-md-12 {
          margin-top: 26px;
          padding: 0 2px;
        }
      }
    }
  }
}
</style>
